module.exports = __webpack_public_path__ + "static/media/290188.fc840339.png";